import { Component, Input } from '@angular/core';
import { UXBlock } from '../../../core/models/ux-page';

@Component({
  selector: 'app-blocks',
  templateUrl: './blocks.component.html',
  styleUrls: ['./blocks.component.scss'],
  host: {
    '[class.row]': 'true'
  }
})
export class BlocksComponent {
  @Input() blocks: UXBlock[]
  @Input() type: 'default' | 'home' = 'default'
}
